import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d90ac87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RecommendedToday" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("签到领苗豆，每日签到可获得5-30苗豆，连续签到可获得更苗豆，苗豆可用于报价，充值，提现等。")
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "titleWarpper" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "specifications" }
const _hoisted_7 = { class: "address" }
const _hoisted_8 = { class: "add" }
const _hoisted_9 = { class: "distance" }
const _hoisted_10 = { class: "itemFooter" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = { class: "btns" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("订阅该品种")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("查看详情")
const _hoisted_15 = { class: "listItem" }
const _hoisted_16 = { class: "cornerMarker" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "profile" }
const _hoisted_19 = { class: "address" }
const _hoisted_20 = { class: "footer" }
const _hoisted_21 = { class: "time" }
const _hoisted_22 = { class: "btns" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("订阅该品种")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("打电话")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_26 = { class: "telNum" }
const _hoisted_27 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanNoticeBar = _resolveComponent("VanNoticeBar")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanTab = _resolveComponent("VanTab")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanTabs = _resolveComponent("VanTabs")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.showCheckIn)
      ? (_openBlock(), _createBlock(_component_VanNoticeBar, {
          key: 0,
          mode: "link",
          color: "#1989fa",
          background: "#ecf9ff",
          "left-icon": "info-o",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name:"CheckIn"})))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_VanTabs, {
      "title-active-color": "#19be6b",
      color: "#19be6b",
      active: $setup.active,
      "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => (($setup.active) = $event)),
      onChange: $setup.tabChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VanTab, { title: "求购" }, {
          default: _withCtx(() => [
            _createVNode(_component_VanList, {
              class: "wantToBuyList",
              onLoad: $setup.getWantToBuyList,
              "immediate-check": false,
              finished: $setup.wFinished,
              "finished-text": "没有更多了"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.wantToBuyList, (item, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "listItem",
                    key: idx,
                    onClick: ($event: any) => ($setup.router.push({name:"BuyDetail",query:{id:item.purchaseId_Str}}))
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
                      _withDirectives(_createElementVNode("div", { class: "num" }, _toDisplayString(item.quotations) + _toDisplayString(item.unit), 513), [
                        [_vShow, item.quotations]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, "规格要求：" + _toDisplayString(item.profile), 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, "用苗地区：" + _toDisplayString(item.areaName), 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString($setup.distance(item.location)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString($setup.timeToNow(Number(item.createTime))), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createVNode(_component_VanButton, {
                          type: "success",
                          size: "small",
                          onClick: _withModifiers(($event: any) => ($setup.subscribe(item.categoryId)), ["stop"]),
                          round: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 2
                        }, 1032, ["onClick"]), [
                          [_vShow, $setup.isSubscribe]
                        ]),
                        _createVNode(_component_VanButton, {
                          type: "primary",
                          size: "small",
                          round: "",
                          color: "#ff5454",
                          onClick: ($event: any) => ($setup.router.push({name:"BuyDetail",query:{id:item.purchaseId_Str}}))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ])
                  ], 8, _hoisted_3))
                }), 128))
              ]),
              _: 1
            }, 8, ["onLoad", "finished"])
          ]),
          _: 1
        }),
        _createVNode(_component_VanTab, { title: "处理" }, {
          default: _withCtx(() => [
            _createVNode(_component_VanList, {
              class: "processingList",
              onLoad: $setup.geProcessingList,
              "immediate-check": false,
              finished: $setup.pFinished,
              "finished-text": "没有更多了"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.processingList, (item, idx) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_VanImage, {
                        src: require("@/assets/img/jiaobiao.png")
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(item.profile), 1),
                    _createElementVNode("div", _hoisted_19, "地区：" + _toDisplayString(item.areaName), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString($setup.timeToNow(Number(item.createTime))), 1),
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createVNode(_component_VanButton, {
                          type: "success",
                          size: "small",
                          onClick: _withModifiers(($event: any) => ($setup.subscribe(item.categoryId)), ["stop"]),
                          round: ""
                        }, {
                          default: _withCtx(() => [
                            _hoisted_23
                          ]),
                          _: 2
                        }, 1032, ["onClick"]), [
                          [_vShow, $setup.isSubscribe]
                        ]),
                        _createVNode(_component_VanButton, {
                          type: "primary",
                          size: "small",
                          round: "",
                          color: "#ff5454",
                          onClick: _withModifiers(($event: any) => ($setup.getTell(item.purchaseId_Str)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_24
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ])
                  ]))
                }), 256))
              ]),
              _: 1
            }, 8, ["onLoad", "finished"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode($setup["RestrictDialog"], {
      modelValue: $setup.restrictShow,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.restrictShow) = $event)),
      code: $setup.restrictCode,
      type: "single"
    }, null, 8, ["modelValue", "code"]),
    _createVNode(_component_VanPopup, {
      class: "callDialog",
      show: $setup.isShowTel,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.isShowTel) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, "是否拨打 " + _toDisplayString($setup.tel), 1),
        _createElementVNode("a", {
          class: "call",
          href: `tel:${$setup.tel}`
        }, "立即呼叫", 8, _hoisted_27)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}